export const getEntityHistoryIsOpen = (state) => state.entityHistory.isOpen;
export const getEntityHistoryRows = (state) => state.entityHistory.rows;
